// ==============================================================
// Fab Build Pro - Mock data (frontend only). Replace with API later.
// ==============================================================

export const company = {
  name: "Fab Build Pro",
  logo: "/fab-build-pro-logo.png",
  tagline: "A High-Quality General Contractor",
  phone: "703-766-6599",
  phoneHref: "tel:+17037666599",
  email: "info@fabbuildpro.com",
  hours: "Open 24 Hours · 24/7 Storm Response",
  address: "1934 Old Gallows Rd STE 350, Vienna, VA 22182",
  areaLabel: "Serving Northern Virginia, Washington D.C. & Maryland",
  rating: 4.9,
  reviewCount: 120,
  googleReviewsUrl:
    "https://www.google.com/maps/place/Fab+Build+Pro/@38.9119272,-77.2224625,722m/data=!3m2!1e3!4b1!4m6!3m5!1s0x89b64b477c8a9a99:0xf59d58cce4a4dde4!8m2!3d38.9119272!4d-77.2224625!16s%2Fg%2F11gns0bkdy",
  mapsEmbedUrl:
    "https://www.google.com/maps?q=Fab+Build+Pro,+1934+Old+Gallows+Rd+STE+350,+Vienna,+VA+22182&output=embed",
  directionsUrl:
    "https://www.google.com/maps/dir/?api=1&destination=1934+Old+Gallows+Rd+STE+350,+Vienna,+VA+22182",
  geo: { latitude: 38.9119272, longitude: -77.2224625 },
  social: {
    facebook: "https://www.facebook.com/fab.built.pro",
    instagram: "https://www.instagram.com/fab.build.pro/",
    youtube: "https://www.youtube.com/@fabiobrankovic8133",
  },
  profiles: [
    { label: "Yelp", url: "https://www.yelp.com/biz/fab-build-pro-vienna" },
    { label: "GAF Certified", url: "https://www.gaf.com/en-us/roofing-contractors/residential/usa/va/vienna/fab-build-pro-1128981" },
    { label: "BBB Profile", url: "https://www.bbb.org/us/va/vienna/profile/general-contractor/fab-build-pro-llc-0241-236023462" },
    { label: "HomeAdvisor", url: "https://www.homeadvisor.com/rated.FabBuildPro.75756088.html" },
  ],
};

export const navLinks = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  {
    label: "Services",
    to: "/services",
    children: [
      { label: "Roofing Services", to: "/services/roofing" },
      { label: "Roof Repair", to: "/services/roof-repair" },
      { label: "Roof Replacement", to: "/services/roof-replacement" },
      { label: "Roof Maintenance", to: "/services/roof-maintenance" },
      { label: "Storm Damage Repairs", to: "/services/storm-damage-repairs" },
      { label: "Siding Services", to: "/services/siding" },
      { label: "Windows Services", to: "/services/windows" },
      { label: "Doors", to: "/services/doors" },
      { label: "Gutters Services", to: "/services/gutters" },
      { label: "Other Services (Remodeling)", to: "/services/remodeling" },
    ],
  },
  { label: "Service Areas", to: "/service-areas" },
  { label: "Reviews", to: "/reviews" },
  { label: "Blog", to: "/blog" },
  { label: "Contact", to: "/contact" },
];

export const hero = {
  eyebrow: "Serving the DMV Area",
  titleTop: "Quality Roofing Contractor",
  titleAccent: "You Can Trust.",
  subtitle:
    "Roof repairs, replacement & installation, storm damage restoration, siding, windows, gutters, doors and more across Northern Virginia, Washington D.C. and Maryland.",
  image: "/img/hero-1.webp",
  images: [
    "/img/hero-1.webp",
    "/img/hero-2.webp",
    "/img/hero-3.webp",
    "/img/hero-4.webp",
    "/img/hero-5.webp",
    "/img/hero-6.webp",
  ],
  badges: ["Licensed & Insured", "Free Roof Inspections", "GAF Master Elite"],
  imageBadge: "The Most Trusted Local Roofing Company",
};

export const stats = [
  { value: "40", suffix: "+", label: "Years of Combined Experience" },
  { value: "5,300", suffix: "+", label: "Projects Completed" },
  { value: "5,300", suffix: "+", label: "Happy Homeowners" },
];

export const whyChoose = {
  eyebrow: "Why You Should Choose Fab Build Pro",
  title: "Your Peace of Mind is Our Top Priority",
  heading: "Why homeowners across the DMV choose Fab Build Pro",
  lead: "Built on Integrity. Driven by Results. Trusted by Thousands.",
  paragraphs: [
    "At Fab Build Pro, we don't just replace roofs, we restore peace of mind. Whether you're a homeowner dealing with storm damage or looking to upgrade your roof for long-term value, our team brings years of expertise, professionalism, and transparency to every project.",
    "We proudly serve the entire DMV area — Northern Virginia, Washington D.C., and Maryland — with one mission: to protect your home with honesty, quality, and care.",
    "As a family-owned and operated, licensed roofing company, we've earned our reputation through integrity, reliability, and results. From navigating insurance claims to offering flexible retail and financing options, we ensure every homeowner gets the best solution for their home, not just the quickest one.",
  ],
  image: "/img/truck.webp",
};

export const services = [
  {
    slug: "roofing",
    title: "Roofing Services",
    short:
      "A full range of attractive, affordable roofing solutions for residential and commercial roofs.",
    icon: "Home",
    image: "/img/reviews.webp",
  },
  {
    slug: "storm-damage-repairs",
    title: "Storm Damage Repairs",
    short:
      "Storm damage can range from mild to severe and is not always easy to spot. Give us a call for a free inspection.",
    icon: "CloudLightning",
    image:
      "https://customer-assets.emergentagent.com/job_fabb-zip-search/artifacts/29y446s0_Do-you-qualify-for-a-free-roof.webp",
  },
  {
    slug: "siding",
    title: "Siding",
    short:
      "With the right siding, you can add color, texture, definition, and character to your home.",
    icon: "LayoutPanelLeft",
    image: "/img/team-siding.webp",
  },
  {
    slug: "windows",
    title: "Windows",
    short:
      "Both retrofit and new construction windows have specific advantages. Let us help you choose.",
    icon: "AppWindow",
    image:
      "https://customer-assets.emergentagent.com/job_fabb-zip-search/artifacts/nvba293c_Expert-Window-Installation-and-Replacement-expert.webp",
  },
  {
    slug: "doors",
    title: "Doors",
    short:
      "Plenty to choose from in a wide range of materials, styles, and designs for every entryway.",
    icon: "DoorOpen",
    image: "/img/doors.webp",
  },
  {
    slug: "gutters",
    title: "Gutters",
    short:
      "Your one-stop-shop for any gutter-related issues — installation, repair and protection.",
    icon: "Waves",
    image:
      "https://customer-assets.emergentagent.com/job_fabb-zip-search/artifacts/2a9r0pas_Professional-Gutter-Repair-Replacement-and-Maintenance.webp",
  },
  {
    slug: "remodeling",
    title: "Remodeling Services",
    short:
      "From kitchens and bathrooms to any room, we provide demo, remodel and addition services.",
    icon: "Hammer",
    image: "/img/remodeling.webp",
  },
];

export const specials = [
  {
    badge: "100% Satisfaction",
    title: "Professional Craftsmanship Secured with 100% Guarantees",
    desc: "Secure your project with full warranties — we guarantee your peace of mind.",
    cta: "Read Our Warranties",
  },
  {
    badge: "25% Off Bundle",
    title: "25% Off On All Additional Work With A Roof",
    desc: "Restore your ENTIRE house with our seasonal special. Claim your special now!",
    cta: "Learn More",
  },
  {
    badge: "15% Off",
    title: "15% Military Special",
    desc: "We make sure everyone who has served is taken care of. Get your roof covered!",
    cta: "Military Special",
  },
  {
    badge: "$200 Off",
    title: "$200 Per Referral",
    desc: "Love what we're doing? Get $200 off current or future projects for every referral.",
    cta: "Refer Now",
  },
  {
    badge: "Pay In Full",
    title: "Cash Offer",
    desc: "Pay in full, get some back. Fab Build Pro offers cash payments with discounted pricing.",
    cta: "View Offer",
  },
  {
    badge: "Financing",
    title: "Our Affordable Financing",
    desc: "Need work done but don't want to empty your pockets? Explore our affordable financing options and apply online in minutes.",
    cta: "Apply Online",
    finance: true,
  },
];

export const testimonials = [
  {
    quote:
      "Fab Build Pro handled our insurance claim from start to finish. New roof, zero stress, and it looks incredible.",
    name: "Marcus D.",
    location: "Fairfax, VA",
    rating: 5,
  },
  {
    quote:
      "After a bad storm we had leaks everywhere. Their crew was out fast, honest about the damage, and the work is flawless.",
    name: "Angela P.",
    location: "Arlington, VA",
    rating: 5,
  },
  {
    quote:
      "Professional from the estimate to clean-up. Fair pricing and they truly stand behind their warranty. Highly recommend.",
    name: "Derek W.",
    location: "Rockville, MD",
    rating: 5,
  },
];

export const certifications = [
  { name: "GAF Master Elite", logo: "/img/cert-1.png" },
  { name: "EDWOSB Certified", logo: "/img/cert-2.png" },
  { name: "WOSB Certified", logo: "/img/cert-3.png" },
  { name: "SWaM Certified", logo: "/img/cert-4.png" },
];

// Individual SEO landing page data for each service area.
export const serviceAreas = [
  { slug: "arlington", name: "Arlington", region: "Arlington County, VA", zips: ["22201", "22203", "22207"] },
  { slug: "chantilly", name: "Chantilly", region: "Fairfax County, VA", zips: ["20151", "20152"] },
  { slug: "annandale", name: "Annandale", region: "Fairfax County, VA", zips: ["22003"] },
  { slug: "burke", name: "Burke", region: "Fairfax County, VA", zips: ["22015"] },
  { slug: "centreville", name: "Centreville", region: "Fairfax County, VA", zips: ["20120", "20121"] },
  { slug: "mclean", name: "McLean", region: "Fairfax County, VA", zips: ["22101", "22102"] },
  { slug: "reston", name: "Reston", region: "Fairfax County, VA", zips: ["20190", "20191"] },
  { slug: "tysons-corner", name: "Tysons Corner", region: "Fairfax County, VA", zips: ["22102", "22182"] },
  { slug: "springfield", name: "Springfield", region: "Fairfax County, VA", zips: ["22150", "22151", "22152"] },
  { slug: "vienna", name: "Vienna", region: "Fairfax County, VA", zips: ["22180", "22182"] },
  { slug: "woodbridge", name: "Woodbridge", region: "Prince William County, VA", zips: ["22191", "22192", "22193"] },
  { slug: "alexandria", name: "Alexandria", region: "City of Alexandria, VA", zips: ["22301", "22304", "22314"] },
  { slug: "sterling", name: "Sterling", region: "Loudoun County, VA", zips: ["20164", "20165", "20166"] },
  { slug: "richmond", name: "Richmond", region: "Richmond, VA", zips: ["23219", "23220"] },
  { slug: "prince-william-county", name: "Prince William County", region: "Northern Virginia", zips: ["22192", "20155", "22026"] },
  { slug: "falls-church", name: "Falls Church", region: "City of Falls Church, VA", zips: ["22042", "22046"] },
  { slug: "gainesville", name: "Gainesville", region: "Prince William County, VA", zips: ["20155", "20156"] },
  { slug: "northern-virginia", name: "Northern Virginia", region: "Northern Virginia", zips: ["22030", "22201", "22314", "20120"] },
  { slug: "hyattsville", name: "Hyattsville", region: "Prince George's County, MD", zips: ["20781", "20782", "20783"] },
  { slug: "rockville", name: "Rockville", region: "Montgomery County, MD", zips: ["20850", "20851", "20852"] },
  { slug: "baltimore", name: "Baltimore", region: "Baltimore, MD", zips: ["21201", "21202", "21230"] },
  { slug: "frederick", name: "Frederick", region: "Frederick County, MD", zips: ["21701", "21702", "21703"] },
];

export const getServiceArea = (slug) =>
  serviceAreas.find((a) => a.slug === slug);

// Display list of city names (derived from serviceAreas).
export const serviceCities = serviceAreas.map((a) => a.name);

// ZIP → City map used by the availability checker (built from serviceAreas).
export const servedZips = serviceAreas.reduce((acc, area) => {
  area.zips.forEach((z) => (acc[z] = area.name));
  return acc;
}, {
  "20001": "Washington D.C.",
  "20009": "Washington D.C.",
  "20781": "Hyattsville",
  "20850": "Rockville",
  "21201": "Baltimore",
  "21701": "Frederick",
});

export const blogPosts = [
  {
    slug: "signs-you-need-a-new-roof",
    title: "7 Warning Signs You Need a New Roof This Year",
    excerpt:
      "From curling shingles to daylight in the attic — here's how to tell when a repair won't cut it and it's time for a full replacement.",
    date: "June 18, 2025",
    category: "Roofing Tips",
    image:
      "https://customer-assets.emergentagent.com/job_fabb-zip-search/artifacts/o5poyoyv_Top-Roof-Maintenance-Tips-You-Need-To-Know--rgx0v5bd8fcssx2rxgdpec6vz53hpll41q25w2jcds.webp",
    body: [
      "Your roof works hard year-round to protect your home from the Mid-Atlantic's heat, humidity, snow, and severe storms. Catching problems early can save you thousands — so here are the warning signs DMV homeowners should never ignore.",
      "1. Curling, cracked, or missing shingles. Shingles that curl at the edges or go missing after a storm leave your decking exposed to water. 2. Granules in your gutters. If you're finding sandy granules washing out of your downspouts, your shingles are wearing out. 3. Daylight or water stains in the attic. Any light coming through the roof boards — or brown stains on ceilings — means water is getting in.",
      "4. Sagging rooflines. A dipping or sagging roof can indicate structural or moisture damage and needs prompt attention. 5. Age. Most asphalt roofs last 20–25 years; if yours is near that range, plan ahead. 6. Rising energy bills. A failing roof lets conditioned air escape. 7. Moss or algae growth trapping moisture against the shingles.",
      "If you're seeing one or more of these signs, schedule a free Fab Build Pro inspection. We'll document everything with photos, give you an honest repair-vs-replace recommendation, and — if storm damage is involved — help you file an insurance claim. Call 703-766-6599 to get started.",
    ],
  },
  {
    slug: "storm-damage-insurance-claims",
    title: "How to Handle a Storm Damage Insurance Claim (The Right Way)",
    excerpt:
      "A step-by-step guide to documenting damage, filing your claim, and getting your roof restored with little to no out-of-pocket cost.",
    date: "June 2, 2025",
    category: "Insurance",
    image:
      "https://customer-assets.emergentagent.com/job_fabb-zip-search/artifacts/fc6e53pk_How-Storm-Damage-Shows-Up-on-Your-Roof.webp",
    body: [
      "After a major storm rolls through Northern Virginia, D.C., or Maryland, filing an insurance claim can feel overwhelming. Done right, though, the process can get your roof fully restored for little more than your deductible. Here's how to do it the right way.",
      "Step 1: Document everything. Take dated photos of any visible damage — missing shingles, dented gutters, debris, interior leaks. Step 2: Schedule a free professional inspection. Fab Build Pro documents damage the way adjusters expect to see it, including hard-to-spot hail and wind damage. Step 3: File promptly. Most policies have a time limit for storm claims, so don't wait.",
      "Step 4: Meet the adjuster with a contractor present. We can be on-site when your insurance adjuster inspects the roof to make sure nothing is missed or undervalued. Step 5: Review the scope and get to work. Once your claim is approved, we complete the restoration to code, using premium materials backed by strong warranties.",
      "Many homeowners are surprised to learn they qualify to replace their roof with little or no out-of-pocket cost beyond the deductible. Fab Build Pro handles the claim from start to finish, so you're never navigating it alone. Call 703-766-6599 for a free storm inspection.",
    ],
  },
  {
    slug: "best-siding-for-dmv-homes",
    title: "The Best Siding Options for DMV Weather",
    excerpt:
      "Vinyl, fiber cement or engineered wood? We break down which siding holds up best against Mid-Atlantic humidity and storms.",
    date: "May 21, 2025",
    category: "Siding",
    image: "/img/team-siding.webp",
    body: [
      "Siding is your home's first line of defense against the DMV's humidity, storms, and temperature swings — and it defines your curb appeal. Choosing the right material means balancing durability, maintenance, and budget.",
      "Vinyl siding is the most popular choice: affordable, low-maintenance, and available in many colors and profiles. Modern insulated vinyl also improves energy efficiency. Fiber cement (like James Hardie) is exceptionally durable, fire-resistant, and stands up beautifully to Mid-Atlantic moisture — a premium option that mimics real wood. Engineered wood offers the authentic look of wood with better resistance to rot and pests.",
      "For most DMV homes, we recommend insulated vinyl for value or fiber cement for longevity and a high-end look. Both resist the humidity and storm exposure common to Virginia, D.C., and Maryland.",
      "Fab Build Pro installs all three, and we'll help you choose based on your home, HOA requirements, and budget. Pair new siding with a roof project and ask about our 25%-off bundle special. Call 703-766-6599 for a free estimate.",
    ],
  },
  {
    slug: "roof-maintenance-guide-dmv",
    title: "The Complete Roof Maintenance Guide for DMV Homeowners",
    excerpt:
      "Simple residential roof maintenance tips to extend your roof's life, prevent leaks, and avoid costly repairs across Northern Virginia, D.C. and Maryland.",
    date: "July 1, 2025",
    category: "Roof Maintenance",
    image:
      "https://customer-assets.emergentagent.com/job_fabb-zip-search/artifacts/o5poyoyv_Top-Roof-Maintenance-Tips-You-Need-To-Know--rgx0v5bd8fcssx2rxgdpec6vz53hpll41q25w2jcds.webp",
    body: [
      "Routine roof maintenance is the single best way to protect your home and avoid expensive surprises. A well-maintained roof can last 25% longer than a neglected one — and here in the DMV, where roofs face humid summers, heavy storms, and winter freeze-thaw cycles, staying ahead of small issues matters even more.",
      "Seasonal roof maintenance checklist: In spring and fall, visually inspect for cracked, curling, or missing shingles, check flashing around chimneys and vents, and look for granule loss (a sign of aging shingles). Keep gutters and downspouts clear so water drains away from your foundation. Trim overhanging branches that scrape shingles or drop debris. After any major storm, do a quick ground-level check for displaced shingles or dented gutters.",
      "Inside the home, watch for the early warning signs of roof trouble: water stains on ceilings, damp spots in the attic, daylight through roof boards, or a musty smell. Catching a small leak early can be a $300 repair; ignoring it can turn into thousands in decking, insulation, and drywall damage.",
      "Residential roof maintenance tips that pay off: schedule a professional inspection once a year (and after severe storms), keep attic ventilation and insulation in good shape to prevent ice dams and heat damage, and address minor repairs immediately. Many homeowners also don't realize storm-related wear may be covered by insurance.",
      "Fab Build Pro offers free, no-obligation roof inspections across Northern Virginia, Washington D.C., and Maryland. We'll document your roof's condition with photos and give you an honest maintenance or repair plan — no pressure. Call 703-766-6599 to schedule yours.",
    ],
  },
  {
    slug: "storm-wind-damage-roof-repair-northern-virginia",
    title: "Storm & Wind Damage Roof Repair in Northern Virginia",
    excerpt:
      "How to spot wind and storm damage on your roof, what to do next, and how Fab Build Pro restores roofs across Northern Virginia — often with little out-of-pocket cost.",
    date: "June 26, 2025",
    category: "Storm Damage",
    image:
      "https://customer-assets.emergentagent.com/job_fabb-zip-search/artifacts/fc6e53pk_How-Storm-Damage-Shows-Up-on-Your-Roof.webp",
    body: [
      "Northern Virginia sees its share of severe weather — high winds, hail, and heavy thunderstorms that can damage even a newer roof. Wind damage isn't always obvious from the ground, so knowing what to look for helps you act before a small problem becomes a major leak.",
      "Common signs of storm and wind damage to a roof include lifted, creased, or missing shingles, granules collecting in gutters and downspouts, dented gutters or flashing, and debris on the roof. Inside, look for new water stains, drips, or damp insulation in the attic after a storm.",
      "What to do after a storm: 1) Safely document any visible damage with photos. 2) Schedule a free professional storm inspection — we spot the wind and hail damage insurance adjusters look for. 3) File your claim promptly, since policies have time limits. 4) Have a contractor present when the adjuster inspects so nothing is missed.",
      "As storm-damage specialists serving Arlington, McLean, Vienna, Fairfax, Alexandria and the entire DMV, Fab Build Pro handles the insurance process from start to finish. Many homeowners qualify to have their roof repaired or fully replaced for little more than their deductible.",
      "If a storm has hit your area, don't wait for a leak to appear. Call 703-766-6599 for a free Northern Virginia storm and wind damage roof inspection.",
    ],
  },
  {
    slug: "gutter-repair-replacement-northern-virginia",
    title: "Gutter Repair & Replacement Services in Northern Virginia",
    excerpt:
      "Signs your gutters need repair or replacement, and how seamless gutters and guards protect your DMV home from costly water damage.",
    date: "June 12, 2025",
    category: "Gutters",
    image:
      "https://customer-assets.emergentagent.com/job_fabb-zip-search/artifacts/2a9r0pas_Professional-Gutter-Repair-Replacement-and-Maintenance.webp",
    body: [
      "Your gutters do a critical job: channeling water away from your roof, siding, and foundation. When they fail, water can cause rot, basement leaks, foundation cracks, and landscape erosion — so gutter repair and replacement is an important part of protecting your Northern Virginia home.",
      "Signs you need gutter repair or replacement include sagging or pulling away from the fascia, rust, cracks or splits, peeling exterior paint, pooling water near the foundation, and gutters that overflow during rain. If your gutters are more than 20 years old or you're constantly cleaning them, replacement is often more cost-effective than ongoing repairs.",
      "We install seamless aluminum gutters custom-formed on-site to minimize leaks, plus gutter guards that keep out leaves and debris and dramatically reduce maintenance. Seamless systems look cleaner and last longer than traditional sectional gutters.",
      "Fab Build Pro provides gutter repair, replacement, and gutter guard installation across Northern Virginia — including McLean, Vienna, Arlington, Reston, and Fairfax — and throughout the DMV. Call 703-766-6599 for a free gutter assessment with any inspection.",
    ],
  },
  {
    slug: "roofing-company-vienna-va",
    title: "How to Choose a Roofing Company in Vienna, VA",
    excerpt:
      "What to look for in a Vienna roofing contractor — licensing, warranties, and local experience — from the team at Fab Build Pro.",
    date: "May 30, 2025",
    category: "Local Guides",
    image: "/img/truck.webp",
    body: [
      "Choosing the right roofing company in Vienna, VA can be the difference between a roof that lasts decades and one that leaks in a few years. As a Vienna-based, family-owned contractor, Fab Build Pro knows exactly what local homes need — and what to look for when hiring a roofer.",
      "First, verify licensing and insurance. A reputable Vienna roofing contractor should be licensed (Class A in Virginia), fully insured, and able to show manufacturer certifications like GAF Master Elite — a designation held by only the top 2% of roofers nationwide, which allows for enhanced warranties.",
      "Next, ask about warranties and get everything in writing. Look for a company that backs both materials and workmanship, provides a clear written estimate, and offers financing options. Be cautious of storm-chasers who show up after bad weather with high-pressure tactics and no local track record.",
      "Local experience matters. A Vienna roofing company that understands Northern Virginia's climate, HOA requirements, and permitting will deliver a smoother project. Reading recent Google reviews (we're proud of our 4.9-star rating) is one of the best ways to judge reliability.",
      "Fab Build Pro provides roof repair, roof replacement, storm damage restoration, siding, windows, and gutters throughout Vienna and the DMV. For a free inspection and honest estimate from your local Vienna roofing contractor, call 703-766-6599.",
    ],
  },
];

export const getBlogPost = (slug) => blogPosts.find((p) => p.slug === slug);

export const faqs = [
  {
    q: "How much does a new roof cost in Northern Virginia?",
    a: "Most residential roof replacements in the DMV range from $8,000 to $25,000 depending on size, pitch, materials, and complexity. Fab Build Pro provides free, no-obligation inspections and written estimates, and we offer flexible financing and 0% interest options.",
  },
  {
    q: "Do you offer free roof inspections and estimates?",
    a: "Yes. Every inspection and estimate is 100% free with no obligation. We document any damage with photos and walk you through your options — repair, replacement, or an insurance claim.",
  },
  {
    q: "Can you help with storm damage insurance claims?",
    a: "Absolutely. We are storm-damage specialists and handle the insurance claim process from start to finish. Many homeowners qualify to have their roof replaced with little or no out-of-pocket cost beyond their deductible.",
  },
  {
    q: "What areas do you serve?",
    a: "We serve the entire DMV — Northern Virginia (Arlington, Fairfax, Alexandria, McLean, Reston, Vienna and more), Washington D.C., and Maryland (Rockville, Baltimore, Frederick, Hyattsville). Enter your ZIP code on our site to confirm availability.",
  },
  {
    q: "Are you licensed and insured?",
    a: "Yes. Fab Build Pro is fully licensed and insured in Virginia (Class A), Washington D.C., and Maryland (MHIC), and we are a GAF Master Elite certified residential roofing contractor.",
  },
  {
    q: "How long does a roof replacement take?",
    a: "Most residential roofs are completed in 1–2 days depending on size and weather. We protect your property, clean up thoroughly, and run a magnetic sweep for nails when we finish.",
  },
  {
    q: "How do I know if I need a roof repair or a full replacement?",
    a: "If your roof is under 15 years old with isolated damage, a repair is often enough. Widespread leaks, missing or curling shingles across large areas, sagging, or granules filling your gutters usually point to replacement. Our free inspection gives you an honest recommendation either way.",
  },
  {
    q: "What roofing materials do you install?",
    a: "We install asphalt architectural shingles (including GAF Timberline), designer and luxury shingles, metal roofing, flat/low-slope systems (TPO, EPDM), and more. As a GAF Master Elite contractor we can offer extended manufacturer warranties most companies can't.",
  },
  {
    q: "What warranties do you offer?",
    a: "We back our workmanship and offer manufacturer material warranties. As GAF Master Elite (top 2% of roofers nationwide), we can provide enhanced GAF system warranties up to 50 years on qualifying installations, plus our 100% satisfaction guarantee.",
  },
  {
    q: "Do you offer financing or payment options?",
    a: "Yes. We offer flexible retail and financing options, including 0% interest plans and discounted cash pricing, plus a 100% price-match. Ask about seasonal specials, our $200 referral credit, and a 15% military discount.",
  },
  {
    q: "How quickly can you respond to a roof leak or storm emergency?",
    a: "We offer 24/7 storm response and can often inspect and tarp/secure an active leak within 24–48 hours across the DMV. Call 703-766-6599 for urgent situations.",
  },
  {
    q: "Do you do more than roofing?",
    a: "Yes — we're a full-service general contractor. In addition to roofing we handle siding, windows, doors, gutters, exterior and interior remodeling, additions, and storm restoration.",
  },
  {
    q: "Will a new roof help with my home insurance or resale value?",
    a: "Often yes. A new, code-compliant roof can lower insurance risk, improve curb appeal, and boost resale value. Many insurers also offer better terms for newer, impact-resistant roofing.",
  },
  {
    q: "How do I get started with Fab Build Pro?",
    a: "Call 703-766-6599, enter your ZIP code on our website, or fill out our free estimate form. We'll schedule a free inspection, document everything, and give you a clear written quote with no pressure.",
  },
];

export const serviceOptions = [
  "Roof Repair",
  "Roof Replacement / Installation",
  "Storm Damage Repair",
  "Siding",
  "Windows",
  "Doors",
  "Gutters",
  "Remodeling",
  "Free Inspection",
  "Other",
];


export const serviceFaqs = [
  // Siding
  {
    q: "What types of siding does Fab Build Pro install?",
    a: "We install vinyl, insulated vinyl, fiber cement (like James Hardie), and engineered wood siding. We'll help you choose the best option for your home's style, HOA requirements, and budget.",
  },
  {
    q: "How long does a siding replacement take?",
    a: "A typical single-family home siding replacement takes 3–7 days depending on square footage, the material chosen, and any repairs needed to the sheathing underneath.",
  },
  {
    q: "Can new siding improve my home's energy efficiency?",
    a: "Yes. Insulated vinyl and properly installed fiber cement with house wrap reduce drafts and improve your home's thermal envelope, which can lower heating and cooling bills.",
  },
  // Windows
  {
    q: "What's the difference between retrofit and new-construction windows?",
    a: "Retrofit (replacement) windows install into your existing frame with minimal disruption — ideal for upgrades. New-construction windows attach to the framing and are used for additions or when the surrounding wall is opened up. We install both.",
  },
  {
    q: "Are your replacement windows energy efficient?",
    a: "Yes. We offer ENERGY STAR-rated, double- and triple-pane windows with low-E glass and insulated frames that cut energy loss and reduce outside noise.",
  },
  // Gutters
  {
    q: "Do you install seamless gutters and gutter guards?",
    a: "Yes. We install seamless aluminum gutters custom-formed to your home to minimize leaks, plus gutter guards to keep out leaves and debris and reduce maintenance.",
  },
  {
    q: "How do I know if my gutters need to be replaced?",
    a: "Common signs include sagging, separating from the fascia, rust or cracks, peeling paint, pooling water near the foundation, or overflowing during rain. We'll assess them free during any inspection.",
  },
  // Doors
  {
    q: "What door materials and styles do you offer?",
    a: "We offer entry, patio, and storm doors in steel, fiberglass, and wood, in a wide range of styles, finishes, and glass options — including energy-efficient and security-focused choices.",
  },
  // Storm damage
  {
    q: "How can I tell if my roof has storm or hail damage?",
    a: "Storm damage isn't always obvious from the ground — look for dented gutters, granules in downspouts, cracked or bruised shingles, and interior water stains. We provide free professional storm inspections and document everything for insurance.",
  },
  {
    q: "Will you work directly with my insurance company?",
    a: "Yes. We're storm-restoration specialists and manage the claim from inspection through completion, meeting your adjuster on-site so nothing gets missed or underpaid.",
  },
  // Remodeling
  {
    q: "What remodeling services do you provide?",
    a: "We handle kitchen and bathroom remodels, room renovations, additions, decks and patios, and full demo-and-rebuild projects — inside and out.",
  },
  {
    q: "Do you provide free estimates for remodeling projects?",
    a: "Yes. We provide free consultations and written estimates for all remodeling work, with transparent pricing and financing options available.",
  },
];
